import React, { useEffect, useState } from 'react'
import { MDBRow, MDBCol } from 'mdb-react-ui-kit'
import Swal from 'sweetalert2'
import axios from '../../../utils/axiosConfig'
import '../../../Pages/Css/modalesMaestros.css'

const FormModalCreateRuta = ({ initialData, onSave, onCancel, ciudades = [], idToEdit }) => {
    const [origen, setOrigen] = useState('')
    const [destino, setDestino] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [latOrigen, setLatOrigen] = useState(null)
    const [lngOrigen, setLngOrigen] = useState(null)
    const [latDestino, setLatDestino] = useState(null)
    const [lngDestino, setLngDestino] = useState(null)
    const [idEdit, setIdEdit] = useState(null)

    // Carga inicial al editar
    useEffect(() => {
        if (!initialData || idToEdit === -1) return

        console.log('Cargando datos iniciales:', initialData)
        console.log('Ciudades disponibles:', ciudades)

        setIdEdit(idToEdit)

        // Ojo: asumo que initialData.origen / destino son IDs de ciudad
        setOrigen(initialData.origen ?? '')
        setDestino(initialData.destino ?? '')
        setDescripcion(initialData.descripcion ?? '')

        // Si vienen coords del back, las usamos.
        setLatOrigen(initialData.latOrigen ?? null)
        setLngOrigen(initialData.lngOrigen ?? null)
        setLatDestino(initialData.latDestino ?? null)
        setLngDestino(initialData.lngDestino ?? null)

        if (idToEdit !== -1) {
            handleOrigenChange({ target: { value: initialData.origen } })
            handleDestinoChange({ target: { value: initialData.destino } })
        }
    }, [initialData, idToEdit, ciudades])

    // Helper para procesar respuesta de la API
    const setCoordsFromResponse = (res, tipo) => {
        const data = res?.data?.data

        if (!Array.isArray(data) || data.length === 0 || !data[0]) {
            console.warn('Respuesta sin datos de coordenadas:', data)
            Swal.fire('Error', 'No se encontraron coordenadas para la ciudad seleccionada', 'error')
            return
        }

        const { Latitud, Longitud } = data[0]

        if (Latitud == null || Longitud == null) {
            console.warn('Latitud/Longitud nulas en respuesta:', data[0])
            Swal.fire('Error', 'La ciudad seleccionada no tiene coordenadas definidas', 'error')
            return
        }

        if (tipo === 'origen') {
            setLatOrigen(Latitud)
            setLngOrigen(Longitud)
        } else if (tipo === 'destino') {
            setLatDestino(Latitud)
            setLngDestino(Longitud)
        }
    }

    // Origen
    const handleOrigenChange = async (e) => {
        const ciudadId = e.target.value
        console.log('Origen seleccionado:', ciudadId)

        setOrigen(ciudadId) // lo guardamos como string para el select

        if (!ciudadId) {
            setLatOrigen(null)
            setLngOrigen(null)
            return
        }

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/maestros/getlocationciudad`,
                { ciudad: ciudadId },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    },
                    withCredentials: true
                }
            )
            console.log('Ubicación de origen:', res.data.data)
            setCoordsFromResponse(res, 'origen')
        } catch (err) {
            console.error('Error fetching origin location:', err)
            Swal.fire('Error', 'Error obteniendo ubicación de origen', 'error')
        }
    }

    // Destino
    const handleDestinoChange = async (e) => {
        const ciudadId = e.target.value
        console.log('Destino seleccionado:', ciudadId)

        setDestino(ciudadId)

        if (!ciudadId) {
            setLatDestino(null)
            setLngDestino(null)
            return
        }

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/maestros/getlocationciudad`,
                { ciudad: ciudadId },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`
                    },
                    withCredentials: true
                }
            )
            console.log('Ubicación de destino:', res.data.data)
            setCoordsFromResponse(res, 'destino')
        } catch (err) {
            console.error('Error fetching destination location:', err)
            Swal.fire('Error', 'Error obteniendo ubicación de destino', 'error')
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!origen || !destino) {
            Swal.fire('Error', 'Debe completar Origen y Destino', 'error')
            return
        }

        if (
            latOrigen == null || lngOrigen == null ||
            latDestino == null || lngDestino == null
        ) {
            Swal.fire(
                'Error',
                'No se pudieron obtener las coordenadas de origen o destino. Verifique las ciudades seleccionadas.',
                'error'
            )
            return
        }

        const payload = {
            id: idEdit,
            origen: parseInt(origen, 10),
            destino: parseInt(destino, 10),
            descripcion,
            latOrigen,
            lngOrigen,
            latDestino,
            lngDestino
        }

        console.log('Guardando ruta:', payload)
        onSave(payload);
    }

    return (
        <form onSubmit={handleSubmit} className="p-3">
            <MDBRow className="mb-3 g-0">
                <MDBCol md="12">
                    <label className="form-label">Origen</label>
                    <select
                        className="form-select"
                        value={origen}
                        onChange={handleOrigenChange}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">Seleccione ciudad de origen</option>
                        {(ciudades || []).map(ciudad => (
                            <option key={ciudad.IDCiudad} value={ciudad.IDCiudad}>
                                {ciudad.NombreCiudad}
                            </option>
                        ))}
                    </select>
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3 g-0">
                <MDBCol md="12">
                    <label className="form-label">Destino</label>
                    <select
                        className="form-select"
                        value={destino}
                        onChange={handleDestinoChange}
                        style={{ boxSizing: 'border-box' }}
                    >
                        <option value="">Seleccione ciudad de destino</option>
                        {(ciudades || []).map(ciudad => (
                            <option key={ciudad.IDCiudad} value={ciudad.IDCiudad}>
                                {ciudad.NombreCiudad}
                            </option>
                        ))}
                    </select>
                </MDBCol>
            </MDBRow>

            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Descripción</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Descripción de la ruta"
                        value={descripcion || ''}
                        onChange={e => setDescripcion(e.target.value)}
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <div className="d-flex justify-content-end">
                <button
                    type="button"
                    className="btn-secondary-modals-maestros me-2"
                    onClick={onCancel}
                >
                    Cancelar
                </button>
                {/* Importante: submit real */}
                <button
                    type="submit"
                    className="btn-primary-modals-maestros"
                >
                    {idToEdit !== -1 ? 'Actualizar' : 'Guardar'}
                </button>
            </div>
        </form>
    )
}

export default FormModalCreateRuta
